import { styled } from "@mui/material/styles";
export const RegisterReviewContainer = styled("div")(
  ({ theme }) =>
    ` width: 100%;
    margin: 0 auto;
    padding: 16px;
    font-family: 'Public Sans', sans-serif;
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;`
);

export const RegisterReviewSection = styled("div")(
  ({ theme }) =>
    `
    margin-bottom: 20px;
    padding: 24px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
  `
);

export const RegisterReviewSectionTitle = styled("h3")(
  ({ theme }) =>
    `
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #387C88;
    font-family: 'Public Sans', sans-serif;
  `
);

export const RegisterReviewSectionContent = styled("div")(
  ({ theme }) =>
    `
    margin-top: 0;
  `
);
